// The last answers from the server kept on this device (login user, shop, shift,
// tables, riders), so the POS can open and sell when there is no internet.

const PREFIX = "offline_copy:";

export const saveCopy = (name, data) => {
  try {
    localStorage.setItem(PREFIX + name, JSON.stringify(data));
  } catch (error) {
    // storage full or blocked: the POS still works online
  }
};

// undefined when this device has no copy
export const readCopy = (name) => {
  try {
    const text = localStorage.getItem(PREFIX + name);
    return text == null ? undefined : JSON.parse(text);
  } catch (error) {
    return undefined;
  }
};

// on logout nothing of this user stays on the device
export const clearCopies = () => {
  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith(PREFIX))
      .forEach((key) => localStorage.removeItem(key));
  } catch (error) {
    // nothing to clear
  }
};
